import { ChainID, TAC_TESTNETS } from '@ankr.com/chains-list';
import { SelectChangeEvent, Typography } from '@mui/material';
import { ArrowDown } from '@ankr.com/ui';

import { ChainGroupID } from 'modules/endpoints/types';
import { ISelectOption } from 'uiKit/Select';
import { NETWORK_INFO_MAP } from 'modules/wallet/constants';
import { Select } from 'modules/common/components/Select';
import { SelectMenuItem } from 'modules/common/components/SelectMenuItem';

import { useChainSelectors } from '../ChainSelectorsProvider';
import { useGroupSelectStyles } from './useGroupSelectStyles';

export interface GroupSelectorProps {
  className?: string;
  classes?: Partial<ReturnType<typeof useGroupSelectStyles>['classes']>;
  disableGroupsWithoutNetwork?: boolean;
  fullWidth?: boolean;
  visible?: boolean;
}

export const GroupSelect = ({
  className,
  classes: classesOverrides,
  disableGroupsWithoutNetwork,
  fullWidth,
  visible = true,
}: GroupSelectorProps) => {
  const { group, groups, setGroupID } = useChainSelectors();

  const { classes, cx } = useGroupSelectStyles(undefined, {
    props: { classes: classesOverrides },
  });

  if (!visible) {
    return null;
  }

  const onChange = (event: SelectChangeEvent<unknown>) => {
    const groupID = event.target.value as ChainGroupID;

    setGroupID(groupID);
  };

  // it's shity hack because of unexpected TAC testnets dependencies and grouping
  // used for chain selector on statistics
  const isTacTestnet = TAC_TESTNETS.includes(group.id as unknown as ChainID);

  const options = groups.map<ISelectOption>(
    ({ chainName, chains, id, name, pluralName, urlsCount }) => {
      const networkInfo = NETWORK_INFO_MAP[chains[0].id || ChainID.UNDEFINED];

      const commonLabel = urlsCount > 1 ? pluralName : name;

      return {
        disabled: disableGroupsWithoutNetwork && !networkInfo,
        label: isTacTestnet ? chainName : commonLabel,
        value: id,
      };
    },
  );

  return (
    <Select
      MenuProps={{
        classes: {
          paper: classes.menuPaper,
        },
      }}
      className={cx(classes.root, classes.select, className)}
      classes={{
        icon: classes.selectIcon,
        select: classes.input,
      }}
      IconComponent={ArrowDown}
      fullWidth={fullWidth}
      onChange={onChange}
      value={group.id}
    >
      {options.map(option => (
        <SelectMenuItem
          disabled={option.disabled}
          key={option.value}
          value={option.value}
        >
          <Typography variant="body2" noWrap>
            {option.label}
          </Typography>
        </SelectMenuItem>
      ))}
    </Select>
  );
};
